// extracted by mini-css-extract-plugin
export default {"FormInput":"PersonalInformationForm_FormInput__Fiwn0"};